import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Link } from "@mui/material";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";





const Automobile = () => {
    const isMobile = useMediaQuery("(max-width: 900px)");

useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top when component loads
      },[]);

    const caseStudies = [
        {
          title: "Transforming infrastructure operations for worldwide data centers",
          company: "BMW Group",
          description:
            "Putting cloud front and center, our Hybrid Infrastructure Managed Services transformed BMW Group's worldwide data centers, enabling global support for their manufacturing and production lines, sales and marketing, showrooms and headquarters.",
          image: "/image/automobilecase.jpg",
          link: "/automotivecs1", // updated
        },
        {
          title: "Accelerating automation for a global automotive components supplier",
          company: "Telefónica and CIE Automotive",
          description:
            "We developed a 5G-enabled logistics platform that enables CIE Automotive to achieve end-to-end automation of its production line, driving productivity and cost efficiency.",
          image: "/image/automotive.jpg",
          link: "/automotivecs2", // updated
        },
      ];
      




return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/automobileimg2.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "40%", md: "15%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "42px", md: "60px" }, // Reduce size slightly for better fit
      }}
    >
     Automobile
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "18px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
   Experience, cutting-edge technology, and years of expertise have allowed automotive companies to move towards an age of mobility in the future. We provide automotive software development services for OEMs, dealers, suppliers, and other automotive businesses seeking solutions for today's industry challenges or new opportunities for tomorrow. </Typography>
  </Box>
</Box>


{/*second section */}


<Box sx={{ position: "relative", overflow: "hidden" }}>
  {/* Background Half-Moon Shape */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      right: 0,
      width: isMobile ? "100%" : "70%",
      height: "100%",
      background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
      borderTopLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      borderBottomLeftRadius: isMobile ? "100% 40%" : "100% 100%",
      zIndex: 0,
    }}
  />

  {/* Actual Content (your original layout) */}
  <Box
    sx={{
      position: "relative",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      width: isMobile ? "100%" : "90%",
      padding: isMobile ? "30px 15px" : "50px 50px",
      gap: "50px",
      boxSizing: "border-box",
      margin: "0 auto",
      minHeight: isMobile ? "auto" : "100vh",
      paddingTop: isMobile ? "120px" : "0px",
      marginBottom: isMobile ? "100px" : "-50px",
      zIndex: 1,
    }}
  >
    {/* Left Content */}
    <Box
      sx={{
        flex: 1,
        textAlign: isMobile ? "center" : "left",
        margin: "0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: isMobile ? "50px" : "60px",
          marginTop: "-10px",
        }}
        mb={5}
      >
        Your partner for intelligent automotive transformation and smart mobility evolution
      </Typography>

      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      With over 50 years of experience, and leading OEMs and suppliers as key clients, Tech Informatic Solutions is your trusted partner for intelligent automotive transformation and smart mobility evolution.   
      </Typography>

      <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
      Our “Connect & Create” strategy develops transformative automotive industry solutions and services. We leverage data values as part of an extended ecosystem to scale new product rollouts, explore joint ventures, use new technologies to accelerate innovation, and deliver advanced automotive use cases globally. 
      </Typography>
    </Box>

    {/* Right Image */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0px",
        marginTop: isMobile ? "50px" : "0px",
      }}
    >
      <img
        src="/image/automotiveimg.jpg"
        alt="About Us"
        style={{
          width: isMobile ? "90%" : "100%",
          maxHeight: "100%",
          objectFit: "cover",
          borderRadius: "10px",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      />
    </Box>
  </Box>
</Box>




{/* 3rd section */}
<Box sx={{  background: "radial-gradient(circle, #1F6788,#161623)",width: "100%", padding: "40px 0" }}>
<Box sx={{ px: { xs: 2, md: 10 }, py: 8 }}>
      {/* Title Section */}
      <Typography variant="h3" color="white" fontWeight="bold" gutterBottom  mb={4}>
        Case Studies
      </Typography>
      <Typography variant="body1" sx={{  fontSize: "18px", color: "white" }}  mb={10}>
        Read how companies in the automotive industry solved their challenges by partnering with Tech Informatic Solutions.
      </Typography>

      {/* Grid Layout */}
      <Grid container spacing={4}>
        {caseStudies.map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card elevation={0} sx={{ border: "1px solid #eee",  boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `, }}>
              <CardMedia
                component="img"
                height="400"
                image={item.image}
                alt={item.title}
              />
              <CardContent>
                <Typography variant="caption" sx={{ color: "#1976d2" }}>
                  {item.company}
                </Typography>
                <Typography variant="h6" fontWeight="bold" mt={1}>
                  {item.title}
                </Typography>
                <Typography variant="body2" mt={1} color="text.secondary">
                  {item.description}
                </Typography>
               
                <Link
  href={item.link}
  target="_blank"
  rel="noopener noreferrer"
  underline="hover"
  sx={{ display: "inline-block", mt: 2, fontWeight: "bold" }}
>
  Read the case study ↗
</Link>

              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
    </Box>


   
<Footer/>
    </>
  );
};
export default Automobile;